var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMdiYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MDI_youtube",
    "data-name": "MDI / youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_youtube",
    "data-name": "Path / youtube",
    d: "M7.667,12.083l3.676-2.125L7.667,7.833v4.25m8.188-5.546a7.323,7.323,0,0,1,.2,1.346c.05.567.071,1.055.071,1.48l.042.6a14.073,14.073,0,0,1-.312,3.421A1.66,1.66,0,0,1,14.63,14.6a9.986,9.986,0,0,1-1.877.2c-.921.05-1.764.071-2.543.071l-1.126.042A28.993,28.993,0,0,1,3.537,14.6,1.66,1.66,0,0,1,2.312,13.38a7.323,7.323,0,0,1-.2-1.346c-.05-.567-.071-1.055-.071-1.48L2,9.958a14.073,14.073,0,0,1,.312-3.421A1.66,1.66,0,0,1,3.537,5.312a9.986,9.986,0,0,1,1.877-.2c.921-.05,1.764-.071,2.543-.071L9.083,5a28.993,28.993,0,0,1,5.546.312A1.66,1.66,0,0,1,15.855,6.537Z",
    transform: "translate(-0.583 -1.458)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiYoutube);
export default __webpack_public_path__ + "static/media/MDI - youtube.b279f9e6d39e588700478ec3bcfeb19a.svg";
export { ForwardRef as ReactComponent };